import type {
  JobSeekerApiAdapter,
  NotificationMutationResponse,
  NotificationSettingUpdate,
  NotificationSettingsResponse,
  NotificationSettingsUpdateResponse,
  NotificationUnreadCountResponse,
  NotificationsResponse,
} from '../types';

const NOTIFICATIONS_ENDPOINT = '/external/api/v1/notifications';
const UNREAD_COUNT_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/unread-count`;
const MARK_READ_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/mark-read`;
const MARK_UNREAD_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/mark-unread`;
const NOTIFICATION_SETTINGS_ENDPOINT = '/external/api/v1/settings/details';
const UPDATE_NOTIFICATION_SETTINGS_ENDPOINT =
  '/external/api/v1/settings/update';

export function getNotifications(
  api: JobSeekerApiAdapter,
  page: number,
  pageSize: number,
  signal?: AbortSignal
) {
  return api.get<NotificationsResponse>(
    NOTIFICATIONS_ENDPOINT,
    { page, pageSize },
    { signal }
  );
}

export function getNotificationUnreadCount(
  api: JobSeekerApiAdapter,
  signal?: AbortSignal
) {
  return api.get<NotificationUnreadCountResponse>(
    UNREAD_COUNT_ENDPOINT,
    undefined,
    { signal }
  );
}

export function readNotificationUnreadCount(
  response: NotificationUnreadCountResponse
): number | null {
  const count = response.data.unreadCount;

  return Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : null;
}

export function markNotificationsRead(
  api: JobSeekerApiAdapter,
  notificationIds: number[],
  signal?: AbortSignal
) {
  return api.put<
    NotificationMutationResponse | undefined,
    { notificationIds: number[] }
  >(MARK_READ_ENDPOINT, { notificationIds }, { signal });
}

export function markNotificationsUnread(
  api: JobSeekerApiAdapter,
  notificationIds: number[],
  signal?: AbortSignal
) {
  return api.put<
    NotificationMutationResponse | undefined,
    { notificationIds: number[] }
  >(MARK_UNREAD_ENDPOINT, { notificationIds }, { signal });
}

export function getNotificationSettings(
  api: JobSeekerApiAdapter,
  signal?: AbortSignal
) {
  return api.get<NotificationSettingsResponse>(
    NOTIFICATION_SETTINGS_ENDPOINT,
    undefined,
    { signal }
  );
}

export function updateNotificationSetting(
  api: JobSeekerApiAdapter,
  setting: NotificationSettingUpdate,
  signal?: AbortSignal
) {
  return api.put<
    NotificationSettingsUpdateResponse | undefined,
    { settings: NotificationSettingUpdate[] }
  >(UPDATE_NOTIFICATION_SETTINGS_ENDPOINT, { settings: [setting] }, { signal });
}
